import { useEffect, useState } from "react";

// react-router-dom components
import { useLocation, NavLink, useSearchParams } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";


import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";


import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";

// Material Dashboard 2 React context
import {
    useMaterialUIController,
    setMiniSidenav,
    setTransparentSidenav,
    setWhiteSidenav,
} from "context";
import { Modal } from "@mui/material";
import MDInput from "components/MDInput";
import { newTicket } from "../../api/routes";
import { toast } from "react-toastify";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    height: 400,
    overflowY: "auto",
};

function Sidenav({ color, brand, brandName, routes, ...rest }) {
    const [searchParams] = useSearchParams()
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
    const location = useLocation();
    const [centerName, setCenterName] = useState();
    const [ticketText, setTicketText] = useState();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const collapseName = location.pathname.replace("/", "");

    let textColor = "white";

    if (transparentSidenav || (whiteSidenav && !darkMode)) {
        textColor = "dark";
    } else if (whiteSidenav && darkMode) {
        textColor = "inherit";
    }
    useEffect(() => {
        if(searchParams.get("collapseNavbar"))
            setMiniSidenav(dispatch, true)
    }, [searchParams.get("collapseNavbar")]);
    const closeSidenav = () => setMiniSidenav(dispatch, true);

    useEffect(() => {
        // A function that sets the mini state of the sidenav.
        function handleMiniSidenav() {
            // setMiniSidenav(dispatch, window.innerWidth < 1200);
            setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
            setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
        }

        /**
         The event listener that's calling the handleMiniSidenav function when resizing the window.
         */
        window.addEventListener("resize", handleMiniSidenav);

        // Call the handleMiniSidenav function to set the state with the initial value.
        handleMiniSidenav();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleMiniSidenav);
    }, [dispatch, location]);

    const newTickets = () => {
        const data = {
            centerName,
            ticketText,
        };
        newTicket(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);

            else {
                handleClose();
                setCenterName("");
                setTicketText("");
                return toast.success("تیکت ارسال شد!");
            }
        });
    };
    // Render all the routes from the routes.js (All the visible items on the Sidenav)
    const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, href, route }) => {
        let returnValue;

        if (type === "collapse") {
            returnValue = href ? (
                <Link
                    href={href}
                    key={key}
                    target="_blank"
                    rel="noreferrer"
                    sx={{ textDecoration: "none" }}
                >
                    <SidenavCollapse
                        name={name}
                        icon={icon}
                        active={key === collapseName}
                        noCollapse={noCollapse}
                    />
                </Link>
            ) : (
                <NavLink key={key} to={route}>
                    <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
                </NavLink>
            );
        } else if (type === "title") {
            returnValue = (
                <MDTypography
                    key={key}
                    color={textColor}
                    display="block"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="uppercase"
                    pl={3}
                    mt={2}
                    mb={1}
                    ml={1}
                >
                    {title}
                </MDTypography>
            );
        } else if (type === "divider") {
            returnValue = (
                <Divider
                    key={key}
                    light={
                        (!darkMode && !whiteSidenav && !transparentSidenav) ||
                        (darkMode && !transparentSidenav && whiteSidenav)
                    }
                />
            );
        }

        return returnValue;
    });

    return (
        <SidenavRoot
            {...rest}
            variant="permanent"
            ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
        >
            <MDBox pt={3} pb={1} px={4} textAlign="center">
                <MDBox
                    display={{ xs: "block", xl: "none" }}
                    position="absolute"
                    top={0}
                    right={0}
                    p={1.625}
                    onClick={closeSidenav}
                    sx={{ cursor: "pointer" }}
                >
                    <MDTypography variant="h6" color="secondary">
                        <Icon sx={{ fontWeight: "bold" }}>close</Icon>
                    </MDTypography>
                </MDBox>
                <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    {miniSidenav && <Icon onClick={() => setMiniSidenav(dispatch, !miniSidenav)} style={{
                        xs: "none",
                        xl: "block",
                        color: "white",
                        cursor: "pointer"
                    }}>{miniSidenav ? "menu_open" : "menu"}</Icon>}
                    <MDBox component={NavLink} to="/dashboard" display="flex" alignItems="center">
                        {brand && !miniSidenav && <MDBox component="img" src={"/images/dashboardLogo.png"} alt="Brand" width="1rem" />}
                        <MDBox
                            width={!brandName && "100%"}
                            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
                        >
                            <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
                                {brandName}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                    <Icon onClick={() => setMiniSidenav(dispatch, !miniSidenav)} style={{
                        xs: "none",
                        xl: "block",
                        color: "white",
                        cursor: "pointer"
                    }}>{miniSidenav ? "menu_open" : "menu"}</Icon>
                </MDBox>

            </MDBox>
            <Divider
                light={
                    (!darkMode && !whiteSidenav && !transparentSidenav) ||
                    (darkMode && !transparentSidenav && whiteSidenav)
                }
            />
            <List>{renderRoutes}</List>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <section style={{ display: "flex", flexDirection: "column" }}>
                        <MDInput value={centerName} onChange={(event) => setCenterName(event.target.value)}
                            label="نام مرکز" />
                        <MDInput value={ticketText} multiline rows={6} label="متن پیام"
                            onChange={(event) => setTicketText(event.target.value)}
                            style={{ marginTop: "2rem" }} />
                        <MDBox mt={4} mb={1}>
                            <MDButton onClick={newTickets} variant="gradient" color="info" sx={{ width: "120px" }}>
                                ارسال تیکت
                            </MDButton>
                        </MDBox>
                    </section>
                </MDBox>
            </Modal>
        </SidenavRoot>
    );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
    color: "info",
    brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
    brand: PropTypes.string,
    brandName: PropTypes.string.isRequired,
    routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
